import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit {
  @Input('search') search: string;
  @Output() newValueEmitEvent = new EventEmitter<String>();
  constructor() {}

  ngOnInit(): void {}

  addNewItem(value: string) {
    this.newValueEmitEvent.emit(value);
  }
}
